import { render, staticRenderFns } from "./LongTermUsers.vue?vue&type=template&id=9d658cfe&scoped=true&"
import script from "./LongTermUsers.vue?vue&type=script&lang=js&"
export * from "./LongTermUsers.vue?vue&type=script&lang=js&"
import style0 from "./LongTermUsers.vue?vue&type=style&index=0&id=9d658cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d658cfe",
  null
  
)

export default component.exports